/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ExternalIdDTO } from './ExternalIdDTO';
import {
    ExternalIdDTOFromJSON,
    ExternalIdDTOFromJSONTyped,
    ExternalIdDTOToJSON,
    ExternalIdDTOToJSONTyped,
} from './ExternalIdDTO';

/**
 * 
 * @export
 * @interface WorkIsPartOfOtherDTO
 */
export interface WorkIsPartOfOtherDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkIsPartOfOtherDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfOtherDTO
     */
    articleId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfOtherDTO
     */
    issue?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfOtherDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfOtherDTO
     */
    pageFirst?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfOtherDTO
     */
    pageLast?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfOtherDTO
     */
    volume?: string;
    /**
     * 
     * @type {Array<ExternalIdDTO>}
     * @memberof WorkIsPartOfOtherDTO
     */
    externalIds?: Array<ExternalIdDTO>;
}

/**
 * Check if a given object implements the WorkIsPartOfOtherDTO interface.
 */
export function instanceOfWorkIsPartOfOtherDTO(value: object): value is WorkIsPartOfOtherDTO {
    return true;
}

export function WorkIsPartOfOtherDTOFromJSON(json: any): WorkIsPartOfOtherDTO {
    return WorkIsPartOfOtherDTOFromJSONTyped(json, false);
}

export function WorkIsPartOfOtherDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkIsPartOfOtherDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'articleId': json['articleId'] == null ? undefined : json['articleId'],
                  'issue': json['issue'] == null ? undefined : json['issue'],
                  'name': json['name'] == null ? undefined : json['name'],
                  'pageFirst': json['pageFirst'] == null ? undefined : json['pageFirst'],
                  'pageLast': json['pageLast'] == null ? undefined : json['pageLast'],
                  'volume': json['volume'] == null ? undefined : json['volume'],
              'externalIds': json['externalIds'] == null ? undefined : ((json['externalIds'] as Array<any>).map(ExternalIdDTOFromJSON)),
    };
}

export function WorkIsPartOfOtherDTOToJSON(json: any): WorkIsPartOfOtherDTO {
    return WorkIsPartOfOtherDTOToJSONTyped(json, false);
}

export function WorkIsPartOfOtherDTOToJSONTyped(value?: WorkIsPartOfOtherDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'articleId': value['articleId'],
        'issue': value['issue'],
        'name': value['name'],
        'pageFirst': value['pageFirst'],
        'pageLast': value['pageLast'],
        'volume': value['volume'],
        'externalIds': value['externalIds'] == null? value['externalIds']: (value['externalIds'] as Array<any>).map(ExternalIdDTOToJSON),
    };
}


